import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { MoreNewsItem }
from '@fuww/components/src/Articles/Sections/MoreNews';
import MoreNewsList from '../../NewsList/Categories/MoreNews';
import MoreNewsCardWithQuery from './MoreNewsCard';
import getArticlesQuery from '../../../../lib/queries/news/getArticlesQuery';
import getArticlesField from '../../../../lib/queries/news/getArticlesField';
import { featuredCategoryIds } from '../../../../lib/mainCategoryIds';
import SiteContext from '../../../SiteContext';
import useNoCacheOnServerFetchPolicy
from '../../../../lib/useNoCacheOnServerFetchPolicy';

const errorMessage = 'Error loading news articles...';

const imageConfigurations = [
  {
    width: 42,
    height: 28,
    quality: 10,
    resize: 'FILL_DOWN',
  },
  { width: 321, height: 214, resize: 'FILL_DOWN' },
  { width: 642, height: 428, resize: 'FILL_DOWN' },
  { width: 720, height: 480, resize: 'FILL_DOWN' },
];

const MoreNewsMixedBlock = ({ variables, showCreatedAt, offset }) => {
  const { prefix, hasLocalNews, newsboard } = useContext(SiteContext);
  const fetchPolicy = useNoCacheOnServerFetchPolicy();

  const field = getArticlesField(prefix, hasLocalNews);
  const query = getArticlesQuery(field);
  const moreNewsVariables = {
    featured: false,
    limit: 1,
    sort: 'CREATED_AT',
    statuses: ['PUBLISHED'],
    categoryIds: featuredCategoryIds,
    newsboards: [newsboard],
    imageConfigurations,
    ...variables,
  };

  return (
    <>
      <MoreNewsItem className="fu-read-more">
        <MoreNewsCardWithQuery
          query={query}
          variables={{
            ...moreNewsVariables,
            offset,
          }}
          errorMessage={errorMessage}
          field={field}
          showCreatedAt={showCreatedAt}
          fetchPolicy={fetchPolicy}
        />
      </MoreNewsItem>
      <MoreNewsItem
        borderRight="1px solid var(--grey-light)"
        padding="0 24px 0 0"
      >
        <MoreNewsCardWithQuery
          query={query}
          variables={{
            ...moreNewsVariables,
            offset: offset + 1,
          }}
          errorMessage={errorMessage}
          field={field}
          showCreatedAt={showCreatedAt}
          fetchPolicy={fetchPolicy}
        />
      </MoreNewsItem>
      <MoreNewsItem
        borderRight="1px solid var(--grey-light)"
        padding="0 24px 0 0"
      >
        <MoreNewsList
          showCategory
          noBorderFirstItem
          categoryHeadline={false}
          variables={variables}
          offset={offset + 2}
          limit={3}
        />
      </MoreNewsItem>
      <MoreNewsItem>
        <MoreNewsList
          categoryHeadline={false}
          noBorderFirstItem
          variables={variables}
          offset={offset + 5}
          limit={4}
        />
      </MoreNewsItem>
    </>
  );
};

MoreNewsMixedBlock.cardinality = 9;

MoreNewsMixedBlock.propTypes = {
  variables: PropTypes.shape({}),
  showCreatedAt: PropTypes.bool,
  offset: PropTypes.number,
};

MoreNewsMixedBlock.defaultProps = {
  variables: null,
  showCreatedAt: false,
  offset: 0,
};

export default MoreNewsMixedBlock;
